const Utils = {
  getScript: function (url, op) {
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.async = true // for firefox3.6
    if (!op) { op = {} } else if (op instanceof Function) { op = { callback: op } }
    if (op.charset) { s.charset = op.charset }
    if (op.crossOrigin) {
      s.crossOrigin = true
    }
    s.src = url
    const h = document.getElementsByTagName('head')[0]
    let done = false
    s.onload = s.onreadystatechange = function () {
      if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
        done = true
        // 防止ie内存泄漏
        s.onload = s.onreadystatechange = null
        if (!op.saveScript) { h.removeChild(s) }
        if (op.callback) { op.callback() }
      }
    }
    h.appendChild(s)
  },

  imageOss: function (url, option) {
    // oss域名白名单排除
    if (url.indexOf('/vthumb.ykimg.com/') > -1 || url.indexOf('.gif') > -1) {
      return url
    }
    if (!option) {
      option = {}
    }
    if (!option.w) {
      option.w = 290
    }
    if (!option.q) {
      option.q = 80
    }
    if (!option.s) {
      option.s = 100
    }
    let type = option.type ? option.type : 'resize'
    let ossStr = ''
    if (type === 'resize') {
      let whStr = option.h ? `w_${option.w},h_${option.h}` : `w_${option.w}`
      ossStr += `resize,${whStr}/interlace,1/quality,Q_${option.q}/sharpen,${option.s}`
    } else if (type === 'crop') {
      ossStr += `resize,w_${option.w}/crop,x_${option.x || 0},y_${option.x || 0},w_${option.w},h_${option.h}`
      ossStr += option.g ? `,${option.g}` : ''
    }
    if (url.indexOf('x-oss-process') > -1) {
      return url
    } else if (url.indexOf('?') > -1) {
      return url + `&x-oss-process=image/${ossStr}`
    } else {
      return url + `?x-oss-process=image/${ossStr}`
    }
  },

  jointUrlParam (url, param) {
    let str = ''
    if (typeof param === 'object') {
      for (let key in param) {
        str += `${key}=${param[key]}&`
      }
      str = str.substr(0, str.length - 1)
    } else {
      str = param
    }
    if (url.indexOf('?') > -1) {
      url += `&${str}`
    } else {
      url += `?${str}`
    }
    return url
  },

  getSpmD: function (index, extStr) {
    extStr = extStr || ''
    return index < 10 ? `d_${extStr}0${index}` : `d_${extStr}${index}`
  },

  getSpmC: function (data) {
    if (!data) {
      return ''
    }
    if (data.moduleId) {
      return `m_${data.moduleId}`
    } else if (data.mid && data.cid) {
      return `m_${data.mid}_c_${data.cid}`
    }
    return ''
  },

  getSpmAB () {
    if (!__isBrowser__) {
      return {}
    }
    return window.spmData || {}
  },

  getComponentSpmData (component) {
    if (!component) {
      return {}
    }
    return {
      'data-spm': component.spm,
      'date-name': 'c_pos'
    }
  },

  /**
   *
   * @param {Object} item
   * @param {Boolean} isnotShow 多个链接一样的 可以不做曝光
   */
  getItemSpmData (item, isnotShow) {
    if (!item) {
      return {}
    }
    const retData = {
      'data-scm': item.scm,
      'data-spm': item.spm,
      'data-name': isnotShow ? '' : 'a_pos'
    }
    if (item.trackInfo) {
      retData['data-trackinfo'] = encodeURIComponent(JSON.stringify(item.trackInfo))
    }
    return retData
  },

  /**
   * 根据数据组合a标签的属性
   * @param {Object} item
   * @param {Boolean} focusBlank 是否强制打开新页面
   */
  getATagProps (item, focusBlank) {
    const props = {
      href: item.link ? item.link : (item.url ? item.url : (item.videoLink ? item.videoLink : '')),
      target: item.isOpenNewTab ? '_blank' : focusBlank ? '_blank' : '_self'
    }
    if (item.title) {
      props.title = item.title
    }
    if (!props.href && item.subRightLink) {
      props.href = item.subRightLink
    }
    if (item.scm) {
      props.href = props.href.match(/\?(.*)/) ? `${props.href}&scm=${encodeURIComponent(item.scm)}` : `${props.href}?scm=${encodeURIComponent(item.scm)}`
    }
    return props
  },

  getDataSet (element) {
    const attrs = element.attributes || {}
    const dataset = {}
    for (const key in attrs) {
      if (attrs[key].name && attrs[key].name.indexOf('data-') > -1) {
        dataset[attrs[key].name.replace('data-', '')] = attrs[key].value
      }
    }
    return dataset
  },
  /**
   * dom节点点击的时候的埋点发送
   * @param {domElement} element
   */
  sendClickLog (element, trackInfo) {
    const dataset = element.dataset || this.getDataSet(element)
    if (!trackInfo) {
      trackInfo = dataset.trackinfo ? dataset.trackinfo : ''
    }
    const exargs = [{
      exargs: {
        'data-spm': dataset.spm,
        'data-scm': dataset.scm,
        'data-trackinfo': trackInfo
      },
      'spm': dataset.spmAnchorId,
      'scm': dataset.scm,
      'aplusContentId': ''
    }]
    const _param = {
      clkdata: JSON.stringify(exargs)
    }
    const arr = []
    for (let key in _param) {
      arr.push(`${key}=${_param[key]}`)
    }
    var q = (window.goldlog_queue || (window.goldlog_queue = []))
    q.push({
      action: 'goldlog.record',
      arguments: ['/yt/youku.pcweb.control', 'CLK', arr.join('&'), 'POST']
    })
  }
}
export default Utils
